import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../App.jsx';
import api from '../services/api.js';
import NavBar from '../components/NavBar.jsx';

const CAT_LABELS = {
  general: '📋 Général', expert: '⭐ Expert', streak: '🔥 Combos', collection: '📚 Collection',
};
const CAT_ORDER = ['general', 'expert', 'streak', 'collection'];

export default function Achievements() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [data, setData] = useState({ achievements: [], total_stars: 0 });

  useEffect(() => {
    api.getAchievements().then(d => setData(d)).catch(() => {});
  }, []);

  const achievements = data?.achievements || [];
  const earned = achievements.filter(a => a.earned).length;

  const grouped = {};
  CAT_ORDER.forEach(c => { grouped[c] = achievements.filter(a => a.category === c); });

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <NavBar />

      <div className="container">
        <button className="back-btn" onClick={() => navigate('/')}>← Retour</button>

        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <h2 style={{ fontSize: '1.4rem', marginBottom: 4 }}>🏆 Hauts faits</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{earned}/{achievements.length} débloqués</p>
        </div>

        <div>
          {CAT_ORDER.map(cat => (
            <div key={cat} style={{ marginBottom: 20 }}>
              <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-muted)', marginBottom: 8 }}>
                {CAT_LABELS[cat]}
              </div>
              <div style={{ display: 'grid', gap: 8 }}>
                {(grouped[cat] || []).map((ach, i) => {
                  const pct = Math.min(100, (ach.progress / ach.condition_value) * 100);
                  return (
                    <motion.div key={ach.slug}
                      className={`achievement-card ${ach.earned ? 'earned' : ''}`}
                      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: i * 0.03 }}>
                      <div className="achievement-icon">{ach.icon}</div>
                      <div className="achievement-info">
                        <div className="achievement-title">{ach.title}</div>
                        <div className="achievement-desc">{ach.description}</div>
                        {!ach.earned && (
                          <div className="achievement-bar">
                            <div className="achievement-bar-fill" style={{ width: `${pct}%` }} />
                            <span className="achievement-bar-text">{ach.progress}/{ach.condition_value}</span>
                          </div>
                        )}
                      </div>
                      <div className="achievement-stars">
                        {ach.earned ? '✅' : `+${ach.stars_reward} pts`}
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
